import { Typography } from '@mui/material';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useAuth } from '../../contexts/authWindows';
import { paths } from '../../utils/core/routes';

export function LogoutPage() {
  const navigate = useNavigate();
  const { signOut, user } = useAuth();

  useEffect(() => {
    if (!user) return;
  }, [user]);

  signOut && signOut();
  navigate(paths.HOME);
  return (
    <>
      {user && signOut && signOut()}
      <Typography>Logging out</Typography>
    </>
  );
}
